/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
import AvatarEditor from 'react-avatar-editor' // https://github.com/mosch/react-avatar-editor
// utils
import { debounce } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- CROPPER --------------- ++++++++++ */
class Cropper extends Component {
    componentWillReceiveProps(nextProps) {
        if (this.props.cta) {
            if (nextProps.activeSelection !== 'none') {
              if(!this.props.isLogoCropper) this.props.toggleActiveSelection()
            }
        }
    };
    onClickSave = () => {
        if (this.editor && !this.props.isGif) {
            // This returns a HTMLCanvasElement, it can be made into a data URL or a blob,
            // drawn on another canvas, or added to the DOM.
            const canvas = this.editor.getImage();
            this.props.setCanvas(canvas);
        }
    };
    setEditorRef = editor => this.editor = editor;
    previewOnZoom = debounce(() => {
        this.props.previewMethod()
    }, 300);
    render() {
        let { imageSize, image, width, height, zoom, previewMethod, selectedEmbedPlacement } = this.props;

        // in-content = 582 x 350
        // rails - 298 x 350
        return (
            <div className={`cropContainer`} >
                <h4 className={`cropperTitle`} >Upload & Crop</h4>
                <AvatarEditor
                    ref={this.setEditorRef}
                    style={imageSize}
                    image={image}
                    // Remove the auto width/height to fix the inconsistency between the cropper and preview ceu bg
                    // this is now the same resolution/aspect ratio with the preview ceu bg
                    width={selectedEmbedPlacement === 'rail' ? width : 582} 
                    height={selectedEmbedPlacement === 'rail' ? height: 350} 
                    border={2.5}
                    scale={Number(zoom)}
                    onImageChange={() => {
                        this.onClickSave();
                        this.previewOnZoom();
                    }}
                    onLoadSuccess={() => {
                        this.onClickSave();
                        previewMethod();
                    }}
                    onMouseUp={previewMethod}
                />
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Cropper;
